/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="66"
        height="66"
        viewBox="0 0 66 66"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M40.5,33.87l-12,6.82a1,1,0,0,1-1.33-.37.94.94,0,0,1-.13-.48V26.2a1,1,0,0,1,1-1,1,1,0,0,1,.48.12l12,6.82a1,1,0,0,1,.37,1.34A1.09,1.09,0,0,1,40.5,33.87Z"
          transform="translate(0 -0.52)"
          fill="#000"
          className="icon-fill"
          fillRule="evenodd"/><circle
          cx="33"
          cy="33"
          r="32"
          stroke="#000"
          fill="none"
          className="icon-stroke"
          strokeWidth="2px"/>
      </svg>

    );
  }
}

Icon.displayName = 'PlayMediaIcon';

export default Icon;
